export enum VisitorRegistrationFormType {
    BusinessTrip = "businessTrip",
    WorkOnSite = 'workOnSite'
}
